import { combineReducers } from 'redux';
import { adsCheckoutReducer } from '../modules/ads-checkout';
import { customerReducer } from '../modules/customers';
import { IStore } from './type';

const rootReducer = combineReducers<IStore>({
  adsCheckout: adsCheckoutReducer,
  customer: customerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/common/rootReducer.ts